// extracted by mini-css-extract-plugin
export default {"imageButton":"+kbol4eIv1XoEOcpB5GHKA=="};